import { Button, Stack, Typography } from "@mui/material";
import { useGetActivePushNotificationCount } from "../hooks";
import { Loader } from "../../../shared";

export const UnpublishDialogContent = ({
  onConfirm,
  onClose,
  id,
  isUnPublishing,
}) => {
  const { count, loading } = useGetActivePushNotificationCount(id);

  return loading ? (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <Loader />
    </Stack>
  ) : (
    <>
      <Typography fontSize="14px" fontWeight={400} lineHeight="16px">
        {count === 0 ? (
          " Are you sure you want to unpublish this coupon?"
        ) : (
          <>
            This action will also cancel {count} push{" "}
            {count === 1 ? "notification" : "notifications"} created for this
            coupon. Are you sure you want to pause this coupon?
          </>
        )}
      </Typography>
      <Stack flexDirection="row" justifyContent="flex-end" mt={2} gap={1.5}>
        <Button size="small" variant="text" color="info" onClick={onClose}>
          No
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={onConfirm}
          disabled={isUnPublishing}
        >
          Yes
        </Button>
      </Stack>
    </>
  );
};
